module.exports = __webpack_public_path__ + "static/Margarine-f861c735aa235209cceb2efd035bffc3.webp";